import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';
import FormLangInput from 'components/forms/FormLangInput';
import FormSwitchery from 'components/forms/FormSwitchery';

class DynamicDataDefinitionData extends EntityPropsUpdater {
  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
    } = this.props;

    if (entityLoaded) {
      return (
        <div class="clearfix">
          <Row>
            <Col xs={12} md={inModal ? 12 : 4}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.formGroup.basic_information}</p>
                  <div class="form-group-attached">
                    <FormInput
                      name="definitionId"
                      label="ID"
                      value={entity.getDefinitionId()}
                      meta={entity.getDefinitionIdMetaInformation()}
                      validation={entity.getDefinitionIdValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormLangInput
                      name="name"
                      label={messages.name}
                      value={entity.getName()}
                      meta={entity.getNameMetaInformation()}
                      validation={entity.getNameValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormAutocomplete
                      name="metaIdentifier"
                      label="Meta identifier"
                      value={entity.getMetaIdentifier()}
                      meta={entity.getMetaIdentifierMetaInformation()}
                      validation={entity.getMetaIdentifierValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      autocompleteType="dynamicDataMetaIdentifier"
                    />
                    {entity.getMetaIdentifier() === 'Client:Client' && (
                      <FormAutocomplete
                        onChange={this.updateEntity}
                        value={entity.getClientType()}
                        meta={entity.getClientTypeMetaInformation()}
                        validation={entity.getClientTypeValidationResult()}
                        label="Client type"
                        name="clientType"
                        options={[
                          { label: 'All', value: '' },
                          { label: 'Employee', value: 'employee' },
                          { label: 'Customer', value: 'customer' },
                        ]}
                        disabled={disabled}
                      />
                    )}
                    <FormAutocomplete
                      onChange={this.updateEntity}
                      value={entity.getType()}
                      meta={entity.getTypeMetaInformation()}
                      validation={entity.getTypeValidationResult()}
                      label="Typ"
                      name="type"
                      options={[{ label: 'string', value: 'string' }]}
                      disabled={disabled}
                    />
                    <div class="form-group form-group-default">
                      <FormSwitchery
                        name="isMultiple"
                        label={messages.select_multiple}
                        value
                        checked={entity.getIsMultiple()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} md={inModal ? 12 : 4}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.security_settings}</p>
                  <div class="form-group-attached">
                    <FormAutocomplete
                      multi
                      name="rolesRead"
                      label={messages.limit_read_rights}
                      value={entity.getRolesRead()}
                      meta={entity.getRolesReadMetaInformation()}
                      validation={entity.getRolesReadValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      autocompleteType="roleMulti"
                      complete
                      stayOpen
                    />
                    <FormAutocomplete
                      multi
                      name="rolesWrite"
                      label={messages.limit_write_rights}
                      value={entity.getRolesWrite()}
                      meta={entity.getRolesWriteMetaInformation()}
                      validation={entity.getRolesWriteValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      autocompleteType="roleMulti"
                      complete
                      stayOpen
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    return null;
  }
}
DynamicDataDefinitionData.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(DynamicDataDefinitionData));
